import { useMapEvents } from 'react-leaflet';
import { toast } from 'sonner';

// Park sınırı çizimi için marker
export function DrawingMarker({ drawnBoundaries, setDrawnBoundaries, setParkForm, parkForm, setDrawingMode }) {
  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      const newPoint = [lat, lng];
      
      // İlk noktaya yakınlık kontrolü (3 noktadan fazla varsa)
      if (drawnBoundaries.length >= 3) {
        const firstPoint = drawnBoundaries[0];
        const distance = Math.sqrt(
          Math.pow(lat - firstPoint[0], 2) + Math.pow(lng - firstPoint[1], 2)
        );
        
        // ~20 metre tolerans (yaklaşık 0.0002 derece) - daha hassas
        if (distance < 0.0002) {
          // Polygon tamamlandı
          setParkForm((prev) => ({
            ...prev,
            boundaries: drawnBoundaries
          }));
          setDrawingMode(false);
          toast.success(`✅ Park sınırı kaydedildi (${drawnBoundaries.length} nokta)`);
          return;
        }
      }
      
      // Yeni nokta ekle
      const updated = [...drawnBoundaries, newPoint];
      setDrawnBoundaries(updated);
      
      if (updated.length < 3) {
        toast.success(`📍 Nokta ${updated.length} eklendi (minimum 3 nokta gerekli)`);
      } else {
        toast.success(`📍 Nokta ${updated.length} eklendi. Bitirmek için ilk noktaya yakın tıklayın.`);
      }
    },
  });
  
  return null;
}
